module.exports = __webpack_public_path__ + "static/media/spei_instructions.1b0e7c35.svg";